import React from "react";
import { FileText, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white py-16 px-4 flex flex-col">
      <div className="max-w-4xl mx-auto w-full">
        {/* Top Header */}
        <div className="flex flex-col items-center text-center mb-10">
          <div className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center mb-6 text-blue-600">
            <FileText className="w-12 h-12" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold uppercase text-gray-900 mb-4 tracking-tight">
            Terms &amp; Conditions
          </h1>
        </div>

        {/* Main Card */}
        <div className="bg-gray-50 rounded-2xl shadow-xl border border-gray-100 p-6 md:p-10 text-left space-y-8">

          {/* Intro */}
          <section className="space-y-3">
            {/* <p className="text-gray-700 font-sans">
              This document is an electronic record in terms of the Information Technology Act, 2000
              and rules thereunder as applicable and the amended provisions pertaining to electronic
              records in various statutes as amended by the Information Technology Act, 2000. This
              electronic record is generated by a computer system and does not require any physical or
              digital signatures.
            </p> */}
            {/* <p className="text-gray-700 font-sans">
              This document is published in accordance with the provisions of Rule 3(1) of the
              Information Technology (Intermediaries Guidelines) Rules, 2011 that require publishing
              the rules and regulations, privacy policy and Terms of Use for access or usage of domain
              name <span className="font-mono">https://exiser.in</span> (&quot;Website&quot;),
              including the related mobile site and mobile application (hereinafter referred to as
              &quot;Platform&quot;).
            </p> */}
            <p className="text-gray-700 font-sans">
              The Platform is owned by <strong>EXISER PVT LTD</strong>, a company incorporated under
              the Companies Act, 2013 with its registered office at Samanpura, Raja Bazar, Patna,
              India (hereinafter referred to as &quot;Platform Owner&quot;, &quot;we&quot;,
              &quot;us&quot;, &quot;our&quot;).
            </p>
            <p className="text-gray-700 font-sans">
              Your use of the Platform and services and tools are governed by the following terms and
              conditions (&quot;Terms of Use&quot;) as applicable to the Platform, including the
              applicable policies which are incorporated herein by way of reference. If you transact
              on the Platform, you shall be subject to the policies that are applicable to the
              Platform for such transaction.
            </p>
            <p className="text-gray-700 font-sans">
              By mere use of the Platform, you shall be contracting with the Platform Owner and these
              terms and conditions, including the policies, constitute your binding obligations with
              the Platform Owner. These Terms of Use relate to your use of our website, goods (as
              applicable) or services (as applicable) (collectively, &quot;Services&quot;).
            </p>
            <p className="text-gray-700 font-sans">
              Any terms and conditions proposed by you which are in addition to or which conflict with
              these Terms of Use are expressly rejected by the Platform Owner and shall be of no force
              or effect.
            </p>
            <p className="text-gray-700 font-sans">
              These Terms of Use can be modified at any time without assigning any reason. It is your
              responsibility to periodically review these Terms of Use to stay informed of updates.
            </p>
            <p className="text-gray-700 font-sans">
              For the purpose of these Terms of Use, wherever the context so requires &quot;you&quot;,
              &quot;your&quot; or &quot;user&quot; shall mean any natural or legal person who has
              agreed to become a user/buyer on the Platform.
            </p>
            <p className="text-gray-900 font-semibold uppercase tracking-wide mt-4">
              ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL
              THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE
              CAREFULLY BEFORE PROCEEDING.
            </p>
            <p className="text-gray-700 font-sans">
              The use of the Platform and/or availing of our Services is subject to the following
              Terms of Use:
            </p>
          </section>

          {/* Main Points 1–10 */}
          <section className="space-y-2">
            <ul className="list-decimal pl-6 space-y-3 text-gray-700 font-sans">
              <li>
                To access and use the Services, you agree to provide true, accurate and complete
                information to us during and after registration, and you shall be responsible for all
                acts done through the use of your registered account on the Platform.
              </li>
              <li>
                Neither we nor any third parties provide any warranty or guarantee as to the accuracy,
                timeliness, performance, completeness or suitability of the information and materials
                offered on this website or through the Services, for any specific purpose. You
                acknowledge that such information and materials may contain inaccuracies or errors and
                we expressly exclude liability for any such inaccuracies or errors to the fullest
                extent permitted by law.
              </li>
              <li>
                Your use of our Services and the Platform is solely and entirely at your own risk and
                discretion for which we shall not be liable to you in any manner. You are required to
                independently assess and ensure that the Services meet your requirements.
              </li>
              <li>
                The contents of the Platform and the Services are proprietary to us and are licensed to
                us. You will not have any authority to claim any intellectual property rights, title,
                or interest in its contents. The contents include and are not limited to the design,
                layout, look and graphics.
              </li>
              <li>
                You acknowledge that unauthorized use of the Platform and/or the Services may lead to
                action against you as per these Terms of Use and/or applicable laws.
              </li>
              <li>
                You agree to pay us the charges associated with availing the Services.
              </li>
              <li>
                You agree not to use the Platform and/or Services for any purpose that is unlawful,
                illegal or forbidden by these Terms, or Indian or local laws that might apply to you.
              </li>
              <li>
                You agree and acknowledge that the Website and the Services may contain links to other
                third party websites. On accessing these links, you will be governed by the terms of
                use, privacy policy and such other policies of such third party websites. These links
                are provided for your convenience to provide further information.
              </li>
              <li>
                You understand that upon initiating a transaction for availing the Services you are
                entering into a legally binding and enforceable contract with the Platform Owner for
                the Services.
              </li>
              <li>
                You understand and agree that all the above terms apply in addition to any specific
                policies or terms mentioned elsewhere on the Platform for particular Services or
                offerings.
              </li>
            </ul>
          </section>

          {/* Indemnity */}
          <section className="space-y-2">
            <h2 className="text-xl font-bold uppercase text-gray-900">Indemnity</h2>
            <p className="text-gray-700 font-sans">
              You shall indemnify and hold harmless the Platform Owner, its affiliates, group
              companies (as applicable) and their respective officers, directors, agents, and
              employees, from any claim or demand, or actions including reasonable attorney&apos;s
              fees, made by any third party or penalty imposed due to or arising out of your breach of
              these Terms of Use, Privacy Policy and other policies, or your violation of any law,
              rules or regulations or the rights (including infringement of intellectual property
              rights) of a third party.
            </p>
          </section>

          {/* Force Majeure */}
          <section className="space-y-2">
            <h2 className="text-xl font-bold uppercase text-gray-900">Force Majeure</h2>
            <p className="text-gray-700 font-sans">
              Notwithstanding anything contained in these Terms of Use, the parties shall not be
              liable for any failure to perform an obligation under these Terms if performance is
              prevented or delayed by a force majeure event.
            </p>
          </section>

          {/* Governing Law & Jurisdiction */}
          <section className="space-y-2">
            <h2 className="text-xl font-bold uppercase text-gray-900">
              Governing Law &amp; Jurisdiction
            </h2>
            <p className="text-gray-700 font-sans">
              These Terms and any dispute or claim relating to it, or its enforceability, shall be
              governed by and construed in accordance with the laws of India.
            </p>
            <p className="text-gray-700 font-sans">
              All disputes arising out of or in connection with these Terms shall be subject to the
              exclusive jurisdiction of the courts in Patna, Bihar.
            </p>
          </section>

          {/* Contact / Communications */}
          <section className="space-y-2">
            <h2 className="text-xl font-bold uppercase text-gray-900">
              Concerns &amp; Communications
            </h2>
            <p className="text-gray-700 font-sans">
              All concerns or communications relating to these Terms shall be sent to the contact
              details provided on the Platform or as otherwise notified by EXISER PVT LTD from time to
              time.
            </p>
          </section>
        </div>

        {/* Back Home */}
        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="flex items-center gap-2 text-exiser-primary font-bold uppercase hover:text-exiser-accent transition-colors group"
          >
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;